export default __webpack_public_path__ + "static/media/elite-master.01301b79.svg";